import { useLocation, useNavigate } from 'react-router-dom';

const useGoBack = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleGoBack = (defaultUrl) => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(defaultUrl);
    }
  };

  return handleGoBack;
};

export default useGoBack;
